// extracted by mini-css-extract-plugin
export var root = "StrapiInlineHubspotForm-module--root--c73b1";
export var titleContainer = "StrapiInlineHubspotForm-module--titleContainer--00810";
export var wrapperColumn = "StrapiInlineHubspotForm-module--wrapperColumn--7fd47";